import { defineMessages } from 'react-intl';

const scope = 'app.components.PaymentSummaryFormModal';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Payment Summary',
  },
  updateButtonLabel: {
    id: `${scope}.updateButtonLabel`,
    defaultMessage: 'Update',
  },
  billableColumnLabel: {
    id: `${scope}.billableColumnLabel`,
    defaultMessage: 'Billable Hour',
  },
  nightColumnLabel: {
    id: `${scope}.nightColumnLabel`,
    defaultMessage: 'Night Hour',
  },
  sundayColumnLabel: {
    id: `${scope}.sundayColumnLabel`,
    defaultMessage: 'Sunday Hour',
  },
  holidayColumnLabel: {
    id: `${scope}.holidayColumnLabel`,
    defaultMessage: 'Holiday Hour',
  },
  hoursColumnLabel: {
    id: `${scope}.hoursColumnLabel`,
    defaultMessage: 'Hours',
  },
  wageColumnLabel: {
    id: `${scope}.wageColumnLabel`,
    defaultMessage: 'Wage',
  },
  wageBonusColumnLabel: {
    id: `${scope}.wageBonusColumnLabel`,
    defaultMessage: 'Wage Bonus',
  },
  priceColumnLabel: {
    id: `${scope}.priceColumnLabel`,
    defaultMessage: 'Price',
  },
  priceBonusColumnLabel: {
    id: `${scope}.priceBonusColumnLabel`,
    defaultMessage: 'Price Bonus',
  },
  bonusColumnLabel: {
    id: `${scope}.bonusColumnLabel`,
    defaultMessage: 'Bonus',
  },
  adminCommentColumnLabel: {
    id: `${scope}.adminCommentColumnLabel`,
    defaultMessage: 'Admin Comment',
  },
  clientCheckinColumnLabel: {
    id: `${scope}.clientCheckinColumnLabel`,
    defaultMessage: 'Client Check In',
  },
  clientCheckoutColumnLabel: {
    id: `${scope}.clientCheckoutColumnLabel`,
    defaultMessage: 'Client Check Out',
  },
});
